/**
 * Vue Router Configuration
 *
 * Defines all routes and navigation for the Cybersecurity and Applied Cryptography Group website.
 * This file maps URLs to their corresponding Vue components.
 *
 * Routes:
 * - / : Homepage with news and publications
 * - /people : Team members overview
 * - /people/:id : Individual member profile (dynamic route)
 * - /research : Research projects
 * - /courses : Courses offered
 * - /thesis : Available and running thesis topics
 * - /publications : Complete publications list
 * - /contact : Contact information and location map
 * - /* : 404 error page for unmatched routes
 */

import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import People from '../views/People.vue'
import Member from '../views/Member.vue'
import Contact from '../views/Contact.vue'
import Publications from '../views/Publications.vue'
import Research from '../views/Research.vue'
import Courses from '../views/Courses.vue'
import Thesis from '../views/Theses.vue'
import Media from '../views/Media.vue'
import Vue from "vue";
import Router from "vue-router";
import PageNotFound from '@/views/PageNotFound.vue'

Vue.use(Router);

// Route definitions
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home  // Homepage: displays news items and recent publications
    },
    {
        path: '/people',
        name: 'People',
        component: People  // Team members overview page
    },
    {
        path: '/people/:id',
        name: 'Member',
        component: Member  // Individual member profile (dynamic :id parameter from members.json)
    },
    {
        path: '/research',
        name: 'Research',
        component: Research  // Research projects and areas showcase
    },
    {
        path: '/courses',
        name: 'Courses',
        component: Courses  // Courses offered by the group
    },
    {
        path: '/thesis',
        name: 'Thesis',
        component: Thesis  // Available and ongoing thesis topics
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact  // Contact information and Google Maps location
    },
    {
        path: '/publications',
        name: 'Publications',
        component: Publications  // Complete publications list
    },
    {
        path: '/media',
        name: 'Media',
        component: Media  // Press articles, interviews, and other media featuring the group
    },
    {
        path: '/:catchAll(.*)*',
        name: "PageNotFound",
        component: PageNotFound  // 404 error page for unmatched routes
    }
]

// Router configuration
const router = new VueRouter({
    mode: 'history',  // Use HTML5 history mode (clean URLs without #)
    base: process.env.BASE_URL,  // Base URL from environment
    routes
})

export default router